import { Space, Typography } from "antd"
import dayjs from "dayjs"
import utc from "dayjs/plugin/utc"

import { titleSortFilters } from "../../../../../Components/titleSortFilters"
import { normalizeMoney } from "../../../../../Utils/normalizeMoney"
import { alertsColumnIconMap, dateFormat } from "../../../../../Utils/utils"

dayjs.extend(utc)

const { Text, Link } = Typography

export const getColumns = () =>
  // {
  //   type: {
  //     key: 'type',
  //     // sorter: true,
  //     title: (state) =>
  //       titleSortFilters({
  //         title: 'Type',
  //         // sorter: true,
  //         icon: 'type',
  //         stateData: state,
  //         key: 'type',
  //       }),
  //     dataIndex: 'type',
  //     // width: 185,
  //   },
  // },
  ({
    id: {
      key: "sequence_number",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "",
          sorter: true,
          icon: alertsColumnIconMap["id"],
          stateData: state,
          key: "sequence_number"
        }),
      dataIndex: "sequence_number",
      width: 60,
      maxWidth: 60
    },
    amount: {
      key: "amount",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Sum",
          // sorter: true,
          icon: alertsColumnIconMap["sum"],
          stateData: state,
          key: "amount"
        }),
      dataIndex: "amount",
      width: 100,
      maxWidth: 100,
      render: (_) => <Text>{normalizeMoney(_) || "—"}</Text>
    },
    user_full_name: {
      key: "user_full_name",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "User full name",
          // sorter: true,
          icon: alertsColumnIconMap["user_full_name"],
          stateData: state,
          key: "user_full_name"
        }),
      dataIndex: "user_full_name"
      // width: 185,
    },
    user_email: {
      key: "user_email",
      // sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "User email",
          // sorter: true,
          icon: alertsColumnIconMap["user_email"],
          stateData: state,
          key: "user_email"
        }),
      dataIndex: "user_email"
      //width: 185,
    },
    created_timestamp: {
      key: "created_timestamp",
      sorter: true,
      title: (state) =>
        titleSortFilters({
          title: "Created date",
          sorter: true,
          icon: alertsColumnIconMap["created_timestamp"],
          stateData: state,
          key: "created_timestamp"
        }),
      dataIndex: "created_timestamp",
      width: 200,
      render: (_) => (
        <Space direction="vertical" size={4}>
          <Text>{dayjs(_).format(dateFormat)}</Text>
          <Text type="secondary">{dayjs(_).format("h:mm A [(UTC)]")}</Text>
        </Space>
      )
    }
  })

export const getDefaultColumn = ({ field_id, label }) => ({
  key: field_id,
  // sorter: true,
  title: (state) =>
    titleSortFilters({
      title: label,
      // sorter: true,
      icon: alertsColumnIconMap[field_id],
      stateData: state,
      key: field_id
    }),
  dataIndex: field_id
  //ellipsis: true,
  // width: 200,
})

export const getActionColumn = ({ onSelectRow }) => ({
  key: "action",
  title: "",
  width: 1,
  // fixed: 'right',
  render: (_, record, index) => <></>
})
